import { render, staticRenderFns } from "./rolesDialog.vue?vue&type=template&id=7bfbf1e4&scoped=true&"
import script from "./rolesDialog.vue?vue&type=script&lang=js&"
export * from "./rolesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfbf1e4",
  null
  
)

export default component.exports